module.exports = __webpack_public_path__ + "img/patient-info-refresh-disable.544b84f0.svg";